<template>
    <div class="header">
        <img v-if="menuBtn" src="@/assets/img/menu.svg" class="back" @click.stop="onMenu">
        <img v-else-if="!isLineMini" src="@/assets/img/menu/back.svg" class="back" @click="back">
        <span class="left suggest" v-if="suggest" @click="onSuggest">
            <img src="@/assets/img/suggest.svg" class="left-icon">
        </span>
        <div class="left">
            <div class="left-content" @click="onShare" v-if="shareUrl">
                <img class="left-icon" src="@/assets/img/share-gray.svg">
            </div>
            <div class="left-content" @click="onLeftBtn" v-if="leftBtn || leftIcon">
                <img class="left-icon" :src="leftIcon" v-if="leftIcon">
                {{ leftBtn }}
                <span class="count" v-if="count > 0">{{ count }}</span>
            </div>
        </div>
        <div class="title">{{ title }}</div>
        <div class="close" v-if="showClose">
            <div class="button" @click="onClose">
                <img src="@/assets/img/+.svg">
                <span>關閉地圖</span>
            </div>
        </div>
        <clear-cart-modal ref="modal" @onConfirm="goToBack"/>
    </div>
</template>

<script>
    import ClearCartModal from './modal/ClearCartModal';
    import { mapGetters } from 'vuex';
    import Swal from 'sweetalert2';

    export default {
        name: 'ShopHeader',
        components: {
            ClearCartModal
        },
        props: {
            title: {
                type: String,
                required: true,
                default: '',
            },
            enabledModal: {
                default: false,
            },
            leftBtn: {
                default: '',
            },
            leftIcon: {
                default: '',
            },
            backRouteLocation: {
                default: null,
            },
            suggest: {
                default: false,
            },
            menuBtn: {
                default: false,
            },
            count: {
                default: -1,
            },
            showClose: {
                type: Boolean,
                default: false,
            },
            shareUrl: {
                type: String,
                default: null,
            }
        },
        data() {
           return {
               showModal: false,
           }
        },
        computed: {
            ...mapGetters(['isLineMini'])
        },
        methods: {
            onMenu() {
                this.$emit('onMenu');
            },
            onSuggest() {
                if (! this.suggest) {
                    return ;
                }

                this.$router.push({
                    name: 'suggest',
                    params: {
                        id: this.suggest
                    }
                });
            },
            onLeftBtn() {
                this.$emit('onLeftBtn');
            },
            onClose() {
                this.$emit('onClose');
            },
            back() {
                if ( ! this.enabledModal) {
                    return this.goToBack();
                }

                this.$refs.modal.show();
            },
            goToBack() {
                if (this.backRouteLocation) {
                    this.$router.replace(this.backRouteLocation);
                } else if (window.history.length > 2) {
                    this.$router.go(-1);
                } else {
                    this.$router.push({
                        name: 'home',
                    });
                }
            },
            onShare() {
                if (navigator.share) {
                    navigator.share({
                        title: '跑跑腿',
                        text: '我分享了跑跑腿任務進度，點擊連結查看進度！',
                        url: this.shareUrl,
                    });
                } else {
                    Swal.fire({
                        title: '訂單分享',
                        html: '複製連結分享您的訂單狀態<br><br>' +
                               '<input type="text" value="' + this.shareUrl + '" id="copy-url">',
                        confirmButtonText: `複製`,
                    }).then((result) => {
                        if (result.value) {
                            const contentToCopy = document.querySelector('#copy-url');
                            contentToCopy.value = "我分享了跑跑腿任務進度，點擊連結查看進度！\n" + this.shareUrl;
                            contentToCopy.select();

                            try {
                                const successful = document.execCommand('copy');
                                if (successful) {
                                    Swal.fire({
                                        title: '複製完成!',
                                        type: 'success',
                                        timer: 2000,
                                    })
                                }
                            } catch (err) {
                                Swal.fire({
                                    title: 'Oops...',
                                    text: '複製失敗，請嘗試手動複製。',
                                    type: 'error',
                                })
                            }
                            window.getSelection().removeAllRanges();
                        }
                    })
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .header {
        padding: 15px;
        position: relative;
    }

    .left {
        position: absolute;
        right: 15px;
        color: #339933;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        display: flex;

        &.suggest {
            right: 70px
        }

        .left-content {
            position: relative;
            cursor: pointer;

            &:nth-child(even) {
                margin-left: 10px;
            }
        }

        .count {
            position: absolute;
            top: -7px;
            right: -7px;
            background: red;
            border-radius: 90px;
            padding: 1px;
            color: white;
            width: 15px;
            height: 15px;
            line-height: 11px;
            font-size: 12px;
            font-weight: 900;
            border: 1px solid #FFFFFF;
            box-sizing: border-box;
        }
    }

    .left-icon {
        width: 25px;
        height: 25px;
        cursor: pointer;
    }

    .title {
        height: 22px;
        color: rgba(0,0,0,1);
        font-size: 14px;
        font-weight: 600;
        letter-spacing: -0.34px;
        line-height: 22px;
        text-align: center;
    }

    .back {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 10px;
    }

    .close {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0,0,0,.4);
        padding: 15px;
        display: flex;

        .button {
            cursor: pointer;
            user-select: none;
            border-radius: 12.5px;
            background-color: #4A4A4A;
            color: #FFFFFF;
            font-size: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 15px 0 5px;
            height: 25px;

            img {
                height: 23px;
                width: auto;
            }
        }
    }
</style>
